import moment from 'moment'

type ExecuteCommandBody = Record<
  string,
  string | number | boolean | null | Array<string | number | boolean>
>

export const normalizeExecuteCommandBody = (
  rawBody: Record<string, unknown>
): ExecuteCommandBody => {
  const normalizedBody: ExecuteCommandBody = {}

  for (const [key, value] of Object.entries(rawBody)) {
    if (value === undefined) {
      continue
    }

    if (value === null) {
      normalizedBody[key] = null
      continue
    }

    if (value instanceof File) {
      continue
    }

    if (moment.isMoment(value)) {
      normalizedBody[key] = value.toISOString()
      continue
    }

    if (value instanceof Date) {
      normalizedBody[key] = value.toISOString()
      continue
    }

    if (Array.isArray(value)) {
      const normalizedArray = value
        .map(item => {
          if (item === undefined || item === null) return null
          if (moment.isMoment(item)) return item.toISOString()
          if (item instanceof Date) return item.toISOString()
          if (typeof item === 'string' || typeof item === 'number') return item

          if (typeof item === 'boolean') return item

          if (typeof item === 'object') {
            const objectItem = item as Record<string, unknown>
            const idCandidate = objectItem.id ?? objectItem.internal_id ?? objectItem._id
            if (typeof idCandidate === 'string' || typeof idCandidate === 'number') {
              return idCandidate
            }
          }

          return String(item)
        })
        .filter(item => item !== null)

      normalizedBody[key] = normalizedArray
      continue
    }

    if (typeof value === 'boolean') {
      normalizedBody[key] = value
      continue
    }

    if (typeof value === 'number') {
      normalizedBody[key] = value
      continue
    }

    if (typeof value === 'string') {
      normalizedBody[key] = value
      continue
    }

    if (typeof value === 'object') {
      const objectValue = value as Record<string, unknown>
      const idCandidate = objectValue.id ?? objectValue.internal_id ?? objectValue._id

      if (typeof idCandidate === 'string' || typeof idCandidate === 'number') {
        normalizedBody[key] = idCandidate
        continue
      }

      normalizedBody[key] = JSON.stringify(objectValue)
      continue
    }

    normalizedBody[key] = String(value)
  }

  return normalizedBody
}
